import React, { useCallback, useState, createContext, useContext } from 'react';
interface AuthContextValue {
  isAuthenticated: boolean;
  login: () => void;
  logout: () => void;
}
const STORAGE_KEY = 'amu-auth';
const AuthContext = createContext<AuthContextValue | undefined>(undefined);
export const AuthProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      return false;
    }
  });
  const login = useCallback(() => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      /* ignore */
    }
    setIsAuthenticated(true);
  }, []);
  const logout = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    setIsAuthenticated(false);
  }, []);
  return <AuthContext.Provider value={{
    isAuthenticated,
    login,
    logout
  }} data-id="element-359">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
};